import React, { Component } from 'react'
import { withTranslation, Trans } from 'react-i18next'
import { ReactSVG } from 'react-svg'
import MedicalVector from './medical-NotFound.svg'
import logoMD from '@resources/assets/img/login-logo.png'
import './SplashScreen.scss'

class PageServerError extends Component {
  render() {
    return (
      <div className="splash-screen" style={styles.container}>
        <img style={styles.waterMark} src={logoMD} alt="splashScreenWatermark" />
        <div style={styles.leftColumn}>
          <ReactSVG style={styles.medicalImage} src={MedicalVector} />
        </div>
        <div style={styles.rightColumn}>
          <div style={styles.largeText}>500</div>
          <div style={styles.secondaryText}>
            <Trans>Error del servidor</Trans>
          </div>
          <div style={{ fontWeight: 600 }}>
            <Trans>Ha habido un error inesperado pruébelo más tarde</Trans>
          </div>
        </div>
      </div>
    )
  }
}

const styles = {
  container: {
    display: 'flex',
    width: '100%',
    height: 'inherit',
    position: 'relative',
    background: 'aliceblue',
  },
  waterMark: {
    width: 313.7,
    height: 50,
    position: 'absolute',
    top: 40,
    left: 40,
    zIndex: 4,
  },
  medicalImage: {
    width: '80%',
  },
  leftColumn: {
    flex: '0 60%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  rightColumn: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1',
    justifyContent: 'center',
    padding: '12px 24px',
  },
  largeText: {
    color: '#01a8e7',
    fontSize: 100,
    lineHeight: 'normal',
    fontWeight: 700,
  },
  secondaryText: {
    color: 'black',
    fontSize: 40,
    lineHeight: 'normal',
    fontWeight: 400,
  },
}

export default withTranslation()(PageServerError)
